module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Find a Cinema")]), _vm._v(" "), _c('h3', [_vm._v("Below you can find all our cinemas and the relevant contact information for each.")])]), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-40": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "gutter-40": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('label', [_vm._v("Select a Cinema")]), _vm._v(" "), (_vm.cinemasByRegion) ? _c('sk-multi-select-regions', {
    staticClass: "filter-select form-group",
    attrs: {
      "val": _vm.selected_cinema,
      "items": _vm.cinemasByRegion
    },
    model: {
      value: (_vm.selected_cinema),
      callback: function($$v) {
        _vm.selected_cinema = $$v
      },
      expression: "selected_cinema"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm6": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), (_vm.regions && _vm.regions != undefined) ? [_vm._l((_vm.filtered_regions), function(region) {
    return [_c('address', [_c('h4', [_vm._v(_vm._s(region.name))]), _vm._v(" "), (region.cinemas) ? [(region.cinemas != undefined) ? [(region.cinemas.length > 0) ? _vm._l((region.cinemas), function(cinema) {
      return _c('sk-panel', {
        key: cinema.id,
        attrs: {
          "transparent": ""
        }
      }, [_c('h5', [_c('a', {
        staticStyle: {
          "text-decoration": "none"
        },
        attrs: {
          "href": '/find-cinemas/' + cinema.slug
        }
      }, [_vm._v(_vm._s(cinema.name))])]), _vm._v(" "), (cinema.address_1 != undefined && cinema.address_2 != undefined && cinema.city != undefined) ? _c('p', [(cinema.address_1 && cinema.address_2 && cinema.city) ? [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAddress: "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cinema.address_1) + ", "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cinema.address_2) + ", "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cinema.city) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")] : [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAddress: "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t185 Katerine Street, "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEastgate Ext.4, "), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tSandton\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]], 2) : _vm._e(), _vm._v(" "), (cinema.phone != undefined) ? _c('p', [(cinema.phone) ? [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tContact the cinema: " + _vm._s(cinema.phone) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")] : [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tContact the cinema: 0861 MOVIES (668437)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]], 2) : _vm._e()])
    }) : [_c('p', [_vm._v("No cinemas available for this region.")])]] : _vm._e()] : _vm._e(), _vm._v(" "), _c('hr')], 2)]
  })] : _vm._e()], 2)], 1)], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23f7fd37","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/cinemas/cinemas.vue
// module id = 724
// module chunks = 0